import { styled } from "@mui/material/styles";

export const EnvTag = styled("img")(() => ({
  marginLeft: "-70px",
  position: "absolute",
  transform: "rotate(-45deg)",
  width: "160px",
}));

export const Logo = styled("img")(({ theme }) => ({
  height: "100%",
  padding: theme.spacing(1, 0),
  paddingLeft: "30px",
}));
